module.exports = __webpack_public_path__ + "static/adeodevsummit-9732b365206c33e8dbe6a08d70b7d650.png";